import { render, staticRenderFns } from "./add-sort.vue?vue&type=template&id=0b3a37c6"
import script from "./add-sort.vue?vue&type=script&lang=js"
export * from "./add-sort.vue?vue&type=script&lang=js"
import style0 from "./add-sort.vue?vue&type=style&index=0&id=0b3a37c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports